export default __webpack_public_path__ + "static/media/pgmico(18).35c5092c.png";